import { RegistryType } from 'components/Shared/Markdown';
import { Categories } from './categories';
import { HeatingArea } from './heatingArea';
import { Articles } from './articles';
import { Ads } from './ads';
import { TextAdLink } from './textAdLink';
import { LatestProducts } from './latestProducts';
import { FaqContainer } from './FaqContainer';
import { SeoSection } from './seo';
import { PopularBrands } from './popularBrands';
import { NewStartPage } from './startPage/newStartPage';

const PREFIX = 'Bygghemma.Commerce.Web.src.views.ContentPage.components';

export const registry = {
  [`${PREFIX}.SeoBlock`]: SeoSection,
  [`${PREFIX}.AdBlock`]: Ads,
  [`${PREFIX}.TextLinkBlock`]: TextAdLink,
  [`${PREFIX}.CategoriesBlock`]: Categories,
  [`${PREFIX}.HeatingBlock`]: HeatingArea,
  [`${PREFIX}.LatestProductsBlock`]: LatestProducts,
  [`${PREFIX}.PopularKnowledgebase`]: Articles,
  [`${PREFIX}.FaqBlock`]: FaqContainer,
  [`${PREFIX}.PopularBrandsBlock`]: PopularBrands,
  [`${PREFIX}.PpNewStartPage`]: NewStartPage
} as RegistryType;
